import React from "react";
import { Modal } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faTimes, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useIntl } from "react-intl";
import { useGlobalCore } from "../../../cores/globals";
import "./SocialWallDeleteModal.scss";

interface Props {
  isOpen: boolean;
  deleting?: boolean;
  accountName?: string;
  previewText?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function SocialWallDeleteModal({
  isOpen,
  deleting,
  accountName,
  previewText,
  onCancel,
  onConfirm,
}: Props) {
  const intl = useIntl();
  const { isDarkMode } = useGlobalCore();
  const snippet = previewText?.trim()
    ? previewText.trim().length > 120
      ? `${previewText.trim().slice(0, 120)}…`
      : previewText.trim()
    : null;

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => !deleting && onCancel()}
      centered
      zIndex={1060}
      className="sw-delete-modal-dialog"
      modalClassName={isDarkMode ? "sw-delete-modal--dark" : undefined}
      backdropClassName="sw-delete-modal__backdrop"
    >
      <div className="sw-delete-modal">
        <button
          type="button"
          className="sw-delete-modal__close"
          onClick={onCancel}
          disabled={deleting}
          aria-label={intl.formatMessage({ id: "app.socialWall.close" })}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="sw-delete-modal__icon" aria-hidden>
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </div>

        <h3 className="sw-delete-modal__title">
          {intl.formatMessage({ id: "app.socialWall.deletePostTitle" })}
        </h3>

        <p className="sw-delete-modal__body">
          {intl.formatMessage({ id: "app.socialWall.deletePostConfirm" })}
        </p>

        {(accountName || snippet) && (
          <div className="sw-delete-modal__preview">
            {accountName ? (
              <div className="sw-delete-modal__preview-account">{accountName}</div>
            ) : null}
            {snippet ? (
              <p className="sw-delete-modal__preview-text">{snippet}</p>
            ) : null}
          </div>
        )}

        <div className="sw-delete-modal__actions">
          <button
            type="button"
            className="sw-delete-modal__btn sw-delete-modal__btn--ghost"
            onClick={onCancel}
            disabled={deleting}
          >
            {intl.formatMessage({ id: "app.socialWall.deletePostCancel" })}
          </button>
          <button
            type="button"
            className="sw-delete-modal__btn sw-delete-modal__btn--danger"
            onClick={onConfirm}
            disabled={deleting}
          >
            <FontAwesomeIcon icon={faTrashAlt} />
            {deleting
              ? intl.formatMessage({ id: "app.socialWall.deletePostWorking" })
              : intl.formatMessage({ id: "app.socialWall.deletePost" })}
          </button>
        </div>
      </div>
    </Modal>
  );
}
